import request from '@/axios'

export function getFinanceApi (page, limit = 5, customer_id, payload) {
  return request({
    url:`finance/list/${customer_id}?page=${page}&limit=${limit}`,
    method:'POST',
    data: payload
  })
}

export function getPaymentModeList (customer_id) {
  return request({
    url: `finance/get_payment_mode_list/${customer_id}`,
    method: 'GET'
  })
}

export function getPaymentStatusList (customer_id) {
  return request({
    url: `finance/get_payment_status_list/${customer_id}`,
    method: 'GET'
  })
}

export function getPayoutUserListApi (customer_id, payload) {
  return request({
    url: `payout/users/${customer_id}`,
    method: 'POST',
    data:payload
    
  })
}

export function getStaffUserList (customer_id, payload, page) {
  return request({
    url: `payout/staff/short/${customer_id}?page=${page}`,
    method: 'POST',
    data:payload
  })
}

export function createPayout (customer_id, payload) {
  return request({
    url: `payout/create/${customer_id}`,
    method: 'POST',
    data:payload
    
  })
}

export function getPayOutListApi (customer_id, payload, page) {
  return request({
    url: `payout/list/${customer_id}?page=${page.page}&limit=${page.limit}`,
    method: 'POST',
    data:payload
    
  })
}

export function staffSinglePayoutDetailsApi (customer_id, payload = []) {
  return request({
    url: `payout/detail/${customer_id}`,
    method: 'POST',
    data:payload
    
  })
}

export function staffPaymentStatusUpdate (customer_id, payload) {
  return request({
    url: `payout/update/payment/${customer_id}`,
    method: 'POST',
    data:payload
    
  })
}

export function staffPaymentSentApi (customer_id, payload) {
  return request({
    url: `payout/update/share/${customer_id}`,
    method: 'POST',
    data:payload
    
  })
}

export function staffListShortApi (customer_id) {
  return request({
    url: `payout/staff/short/${customer_id}`,
    method: 'POST'
    
  })
}

export function staffDeleteApi (customer_id, payload) {
  return request({
    url: `payout/delete/${customer_id}`,
    method: 'POST',
    data:payload
    
  })
}

export function getPdfDownload (customer_id, payload) {
  return request({
    url: `payout/download/pdf/${customer_id}`,
    method: 'POST',
    data:payload
    
  })
}

export function getPdfDownloadByClient (customer_id, payload) {
  return request({
    url: `finance/pdf/${customer_id}`,
    method: 'POST',
    data:payload
    
  })
}

export function fetchStudentFinanceBySearch (payload, page = 1, limit = 5, query = {}) {
  let url = 'finance/global_search'
  if (Object.entries(query).length > 0) {
    url = `${url  }?attribute=${query ? query.attribute : ''}&direction=${query.direction}&field_type=${query.field_type}&page=${page}&limit=${limit}` 
  }
  return request({
    url,
    method: 'POST',
    data:payload
    
  })
}
export function fetchStaffFinanceBySearch (payload, page, query = {}) {
  let url = 'payout/global_search'
  if (Object.entries(query).length > 0) {
    url = `${url  }?attribute=${query ? query.attribute : ''}&direction=${query.direction}&field_type=${query.field_type}&page=${page}` 
  }
  return request({
    url,
    method: 'POST',
    data:payload
    
  })
}